module.exports = __webpack_public_path__ + "static/media/hammock.467e6368.svg";